import storage from 'kv-storage-polyfill'

export default class Storage {
	constructor () {
		this.prefix = process.env.VUE_APP_STORAGE_PREFIX
		this.joinStr = '__'
	}

	/**
	 * ストレージキーを取得
	 * @param {String} target key生成用の文字列
	 * @return {String} key ストレージキー
	 */
	getStorageKey (target) {
		const { prefix, joinStr } = this
		const key = [prefix, target].join(joinStr)
		return key
	}

	/**
	 * ストレージのデータを取得
	 * @param {String} target key生成用の文字列
	 * @return {*} d 保持していたデータ
	 */
	async get (target) {
		const key = this.getStorageKey(target)
		const d = await storage.get(key)
		return d
	}

	/**
	 * ストレージにデータを設定
	 * @param {String} target key生成用の文字列
	 * @param {*} data 保存するデータ
	 */
	async set (target, data) {
		const key = this.getStorageKey(target)
		await storage.set(key, data)
	}

	/**
	 * ストレージのデータを削除
	 * @param {String} target key生成用の文字列
	 */
	async delete (target) {
		const key = this.getStorageKey(target)
		await storage.delete(key)
	}

	/**
	 * ストレージ内のすべてのデータを取得
	 * @param {String} target key生成用の文字列
	 * @return {Array} d ストレージ内のすべてのデータ
	 */
	async entries () {
		const d = []
		for await (const [key, value] of storage.entries()) {
			const values = {}
			values[key] = value
			d.push(values)
		}
		return d
	}
}
